"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _vue = _interopRequireDefault(require("vue"));
var _router = _interopRequireDefault(require("@/router"));
var _helpers = require("@/helpers");
var _underLoading = require("../helpers/under-loading");
var _services = require("@/services");
var MutationTypes = _interopRequireWildcard(require("../mutation-types"));
var _http = _interopRequireDefault(require("@/config/http"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t26 in e) "default" !== _t26 && {}.hasOwnProperty.call(e, _t26) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t26)) && (i.get || i.set) ? o(f, _t26, i) : f[_t26] = e[_t26]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var state = {
  plots: []
};
var mutations = _defineProperty(_defineProperty({}, MutationTypes.ADD_PLOTS, function (state, _ref) {
  var data = _ref.data;
  _vue.default.set(state, 'plots', data);
}), MutationTypes.REMOVE_ALL_PLOTS, function (state) {
  _vue.default.set(state, 'plots', []);
});
var getters = {
  allPlots: function allPlots(state) {
    return state.plots;
  }
};
var actions = {
  createSelectedPlots: function createSelectedPlots(_ref2) {
    var commit = _ref2.commit,
      dispatch = _ref2.dispatch;
    commit(MutationTypes.ADD_SCHEDULE_PLOTS, {
      data: state.plots
    });
  },
  removeAllPlots: function removeAllPlots(_ref3, plots) {
    var commit = _ref3.commit,
      dispatch = _ref3.dispatch;
    commit(MutationTypes.REMOVE_ALL_PLOTS, {
      plots: plots
    });
  },
  createPlot: (0, _underLoading.underLoadingFunction)(/*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(_ref4, payload) {
      var commit, rootState, farmId, response, successMessage, _t;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.p = _context.n) {
          case 0:
            commit = _ref4.commit, rootState = _ref4.rootState;
            _context.p = 1;
            farmId = rootState.farm.farm.id;
            _context.n = 2;
            return _services.plotService.createPlot(farmId, payload);
          case 2:
            response = _context.v;
            successMessage = _router.default.app.$t('create_plot_success');
            _helpers.messageHelper.success(successMessage);
            return _context.a(2, response.data);
          case 3:
            _context.p = 3;
            _t = _context.v;
            _helpers.errorResponseHelper.display(_t);
            return _context.a(2, false);
        }
      }, _callee, null, [[1, 3]]);
    }));
    return function (_x, _x2) {
      return _ref5.apply(this, arguments);
    };
  }()),
  updatePlot: (0, _underLoading.underLoadingFunction)(/*#__PURE__*/function () {
    var _ref7 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(_ref6, payload) {
      var commit, rootState, response, successMessage, _t2;
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.p = _context2.n) {
          case 0:
            commit = _ref6.commit, rootState = _ref6.rootState;
            _context2.p = 1;
            _context2.n = 2;
            return _services.plotService.updatePlot(payload);
          case 2:
            response = _context2.v;
            successMessage = _router.default.app.$t('update_plot_success');
            _helpers.messageHelper.success(successMessage);
            return _context2.a(2, response.data);
          case 3:
            _context2.p = 3;
            _t2 = _context2.v;
            _helpers.errorResponseHelper.display(_t2);
            return _context2.a(2, false);
        }
      }, _callee2, null, [[1, 3]]);
    }));
    return function (_x3, _x4) {
      return _ref7.apply(this, arguments);
    };
  }()),
  fetchPlots: (0, _underLoading.underLoadingFunction)(/*#__PURE__*/function () {
    var _ref9 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(_ref8) {
      var commit, rootState, response, _t3;
      return _regenerator().w(function (_context3) {
        while (1) switch (_context3.p = _context3.n) {
          case 0:
            commit = _ref8.commit, rootState = _ref8.rootState;
            _context3.p = 1;
            _context3.n = 2;
            return _services.plotService.fetchPlots(rootState.farm.farm.id);
          case 2:
            response = _context3.v;
            commit(MutationTypes.ADD_PLOTS, {
              data: response.data
            });
            return _context3.a(2, response.data);
          case 3:
            _context3.p = 3;
            _t3 = _context3.v;
            _helpers.errorResponseHelper.display(_t3);
            return _context3.a(2, false);
        }
      }, _callee3, null, [[1, 3]]);
    }));
    return function (_x5) {
      return _ref9.apply(this, arguments);
    };
  }()),
  deletePlot: (0, _underLoading.underLoadingFunction)(/*#__PURE__*/function () {
    var _ref1 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(_ref0, id) {
      var commit, rootState, response, successMessage, _t4;
      return _regenerator().w(function (_context4) {
        while (1) switch (_context4.p = _context4.n) {
          case 0:
            commit = _ref0.commit, rootState = _ref0.rootState;
            _context4.p = 1;
            _context4.n = 2;
            return _services.plotService.deletePlot(id);
          case 2:
            response = _context4.v;
            successMessage = _router.default.app.$t('pages.productive_areas.list.alerts.delete_plot_success');
            _helpers.messageHelper.success(successMessage);
            return _context4.a(2, response);
          case 3:
            _context4.p = 3;
            _t4 = _context4.v;
            _helpers.errorResponseHelper.display(_t4);
            return _context4.a(2, false);
        }
      }, _callee4, null, [[1, 3]]);
    }));
    return function (_x6, _x7) {
      return _ref1.apply(this, arguments);
    };
  }()),
  fetchPlotItem: (0, _underLoading.underLoadingFunction)(/*#__PURE__*/function () {
    var _ref11 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(_ref10, id) {
      var commit, rootState, response, _t5;
      return _regenerator().w(function (_context5) {
        while (1) switch (_context5.p = _context5.n) {
          case 0:
            commit = _ref10.commit, rootState = _ref10.rootState;
            _context5.p = 1;
            _context5.n = 2;
            return _services.plotService.fetchPlotItem(id);
          case 2:
            response = _context5.v;
            return _context5.a(2, response.data);
          case 3:
            _context5.p = 3;
            _t5 = _context5.v;
            _helpers.errorResponseHelper.display(_t5);
            return _context5.a(2, false);
        }
      }, _callee5, null, [[1, 3]]);
    }));
    return function (_x8, _x9) {
      return _ref11.apply(this, arguments);
    };
  }()),
  fetchSubPlot: (0, _underLoading.underLoadingFunction)(/*#__PURE__*/function () {
    var _ref13 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(_ref12, idPlot) {
      var commit, dispatch, response, _t6;
      return _regenerator().w(function (_context6) {
        while (1) switch (_context6.p = _context6.n) {
          case 0:
            commit = _ref12.commit, dispatch = _ref12.dispatch;
            _context6.p = 1;
            _context6.n = 2;
            return _services.plotService.fetchSubPlot(idPlot);
          case 2:
            response = _context6.v;
            return _context6.a(2, response.data);
          case 3:
            _context6.p = 3;
            _t6 = _context6.v;
            _helpers.errorResponseHelper.display(_t6);
            return _context6.a(2, false);
        }
      }, _callee6, null, [[1, 3]]);
    }));
    return function (_x0, _x1) {
      return _ref13.apply(this, arguments);
    };
  }()),
  createSubPlot: (0, _underLoading.underLoadingFunction)(/*#__PURE__*/function () {
    var _ref15 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7(_ref14, payload) {
      var commit, dispatch, response, successMessage, _t7;
      return _regenerator().w(function (_context7) {
        while (1) switch (_context7.p = _context7.n) {
          case 0:
            commit = _ref14.commit, dispatch = _ref14.dispatch;
            _context7.p = 1;
            _context7.n = 2;
            return _services.plotService.createSubPlot(payload.idPlot, payload.data);
          case 2:
            response = _context7.v;
            successMessage = _router.default.app.$t('create_subplot_success');
            _helpers.messageHelper.success(successMessage);
            return _context7.a(2, response);
          case 3:
            _context7.p = 3;
            _t7 = _context7.v;
            _helpers.errorResponseHelper.display(_t7);
            return _context7.a(2, false);
        }
      }, _callee7, null, [[1, 3]]);
    }));
    return function (_x10, _x11) {
      return _ref15.apply(this, arguments);
    };
  }()),
  generateStructure: (0, _underLoading.underLoadingFunction)(/*#__PURE__*/function () {
    var _ref17 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8(_ref16, payload) {
      var commit, dispatch, response, successMessage, _t8;
      return _regenerator().w(function (_context8) {
        while (1) switch (_context8.p = _context8.n) {
          case 0:
            commit = _ref16.commit, dispatch = _ref16.dispatch;
            _context8.p = 1;
            _context8.n = 2;
            return _services.plotService.generateStructure(payload.idSubPlot, payload.data);
          case 2:
            response = _context8.v;
            successMessage = _router.default.app.$t('success');
            _helpers.messageHelper.success(successMessage);
            return _context8.a(2, response);
          case 3:
            _context8.p = 3;
            _t8 = _context8.v;
            _helpers.errorResponseHelper.display(_t8);
            return _context8.a(2, false);
        }
      }, _callee8, null, [[1, 3]]);
    }));
    return function (_x12, _x13) {
      return _ref17.apply(this, arguments);
    };
  }()),
  deleteSubPlot: (0, _underLoading.underLoadingFunction)(/*#__PURE__*/function () {
    var _ref19 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee9(_ref18, id) {
      var commit, rootState, response, successMessage, _t9;
      return _regenerator().w(function (_context9) {
        while (1) switch (_context9.p = _context9.n) {
          case 0:
            commit = _ref18.commit, rootState = _ref18.rootState;
            _context9.p = 1;
            _context9.n = 2;
            return _services.plotService.deleteSubPlot(id);
          case 2:
            response = _context9.v;
            successMessage = _router.default.app.$t('pages.productive_areas.detail.alerts.delete_subplot_success');
            _helpers.messageHelper.success(successMessage);
            return _context9.a(2, response);
          case 3:
            _context9.p = 3;
            _t9 = _context9.v;
            _helpers.errorResponseHelper.display(_t9);
            return _context9.a(2, false);
        }
      }, _callee9, null, [[1, 3]]);
    }));
    return function (_x14, _x15) {
      return _ref19.apply(this, arguments);
    };
  }()),
  updateSubPlot: (0, _underLoading.underLoadingFunction)(/*#__PURE__*/function () {
    var _ref21 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee0(_ref20, payload) {
      var commit, dispatch, response, successMessage, _t0;
      return _regenerator().w(function (_context0) {
        while (1) switch (_context0.p = _context0.n) {
          case 0:
            commit = _ref20.commit, dispatch = _ref20.dispatch;
            _context0.p = 1;
            _context0.n = 2;
            return _services.plotService.updateSubPlot(payload.idSubPlot, payload.data);
          case 2:
            response = _context0.v;
            successMessage = _router.default.app.$t('success');
            _helpers.messageHelper.success(successMessage);
            return _context0.a(2, response);
          case 3:
            _context0.p = 3;
            _t0 = _context0.v;
            _helpers.errorResponseHelper.display(_t0);
            return _context0.a(2, false);
        }
      }, _callee0, null, [[1, 3]]);
    }));
    return function (_x16, _x17) {
      return _ref21.apply(this, arguments);
    };
  }()),
  fetchRow: (0, _underLoading.underLoadingFunction)(/*#__PURE__*/function () {
    var _ref23 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee1(_ref22, payload) {
      var commit, dispatch, response, _t1;
      return _regenerator().w(function (_context1) {
        while (1) switch (_context1.p = _context1.n) {
          case 0:
            commit = _ref22.commit, dispatch = _ref22.dispatch;
            _context1.p = 1;
            _context1.n = 2;
            return _services.plotService.fetchRow(payload.idSubPlot, payload.filter, payload.page, payload.limit);
          case 2:
            response = _context1.v;
            return _context1.a(2, response.data);
          case 3:
            _context1.p = 3;
            _t1 = _context1.v;
            _helpers.errorResponseHelper.display(_t1);
            return _context1.a(2, false);
        }
      }, _callee1, null, [[1, 3]]);
    }));
    return function (_x18, _x19) {
      return _ref23.apply(this, arguments);
    };
  }()),
  createRow: (0, _underLoading.underLoadingFunction)(/*#__PURE__*/function () {
    var _ref25 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee10(_ref24, payload) {
      var commit, dispatch, response, successMessage, _t10;
      return _regenerator().w(function (_context10) {
        while (1) switch (_context10.p = _context10.n) {
          case 0:
            commit = _ref24.commit, dispatch = _ref24.dispatch;
            _context10.p = 1;
            _context10.n = 2;
            return _services.plotService.createRow(payload.idSubPlot, payload.data);
          case 2:
            response = _context10.v;
            successMessage = _router.default.app.$t('success');
            _helpers.messageHelper.success(successMessage);
            return _context10.a(2, response);
          case 3:
            _context10.p = 3;
            _t10 = _context10.v;
            _helpers.errorResponseHelper.display(_t10);
            return _context10.a(2, false);
        }
      }, _callee10, null, [[1, 3]]);
    }));
    return function (_x20, _x21) {
      return _ref25.apply(this, arguments);
    };
  }()),
  updateRow: (0, _underLoading.underLoadingFunction)(/*#__PURE__*/function () {
    var _ref27 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee11(_ref26, payload) {
      var commit, dispatch, _yield$plotService$up, data, successMessage, _t11;
      return _regenerator().w(function (_context11) {
        while (1) switch (_context11.p = _context11.n) {
          case 0:
            commit = _ref26.commit, dispatch = _ref26.dispatch;
            _context11.p = 1;
            _context11.n = 2;
            return _services.plotService.updateRow(payload.id, payload.data);
          case 2:
            _yield$plotService$up = _context11.v;
            data = _yield$plotService$up.data;
            successMessage = _router.default.app.$t('success');
            _helpers.messageHelper.success(successMessage);
            return _context11.a(2, data);
          case 3:
            _context11.p = 3;
            _t11 = _context11.v;
            _helpers.errorResponseHelper.display(_t11);
            return _context11.a(2, false);
        }
      }, _callee11, null, [[1, 3]]);
    }));
    return function (_x22, _x23) {
      return _ref27.apply(this, arguments);
    };
  }()),
  deleteRow: (0, _underLoading.underLoadingFunction)(/*#__PURE__*/function () {
    var _ref29 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee12(_ref28, id) {
      var commit, rootState, response, successMessage, _t12;
      return _regenerator().w(function (_context12) {
        while (1) switch (_context12.p = _context12.n) {
          case 0:
            commit = _ref28.commit, rootState = _ref28.rootState;
            _context12.p = 1;
            _context12.n = 2;
            return _services.plotService.deleteRow(id);
          case 2:
            response = _context12.v;
            successMessage = _router.default.app.$t('pages.productive_areas.detail.alerts.delete_row_success');
            _helpers.messageHelper.success(successMessage);
            return _context12.a(2, response);
          case 3:
            _context12.p = 3;
            _t12 = _context12.v;
            _helpers.errorResponseHelper.display(_t12);
            return _context12.a(2, false);
        }
      }, _callee12, null, [[1, 3]]);
    }));
    return function (_x24, _x25) {
      return _ref29.apply(this, arguments);
    };
  }()),
  fetchFamilies: (0, _underLoading.underLoadingFunction)(/*#__PURE__*/function () {
    var _ref32 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee13(_ref30, _ref31) {
      var commit, dispatch, parentId, page, limit, filter, response, _t13;
      return _regenerator().w(function (_context13) {
        while (1) switch (_context13.p = _context13.n) {
          case 0:
            commit = _ref30.commit, dispatch = _ref30.dispatch;
            parentId = _ref31.parentId, page = _ref31.page, limit = _ref31.limit, filter = _ref31.filter;
            _context13.p = 1;
            _context13.n = 2;
            return _services.plotService.fetchFamilies(parentId, {
              page: page,
              limit: limit,
              filter: filter
            });
          case 2:
            response = _context13.v;
            return _context13.a(2, response.data);
          case 3:
            _context13.p = 3;
            _t13 = _context13.v;
            _helpers.errorResponseHelper.display(_t13);
            return _context13.a(2, false);
        }
      }, _callee13, null, [[1, 3]]);
    }));
    return function (_x26, _x27) {
      return _ref32.apply(this, arguments);
    };
  }()),
  listServiceTechnics: (0, _underLoading.underLoadingFunction)(/*#__PURE__*/function () {
    var _ref34 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee14(_ref33, idProduct) {
      var commit, rootState, farmId, _yield$servicesServic, data, _t14;
      return _regenerator().w(function (_context14) {
        while (1) switch (_context14.p = _context14.n) {
          case 0:
            commit = _ref33.commit, rootState = _ref33.rootState;
            _context14.p = 1;
            farmId = rootState.farm.farm.id;
            _context14.n = 2;
            return _services.servicesService.listServiceTechnics(idProduct, farmId);
          case 2:
            _yield$servicesServic = _context14.v;
            data = _yield$servicesServic.data;
            return _context14.a(2, data);
          case 3:
            _context14.p = 3;
            _t14 = _context14.v;
            _helpers.errorResponseHelper.display(_t14);
            return _context14.a(2, false);
        }
      }, _callee14, null, [[1, 3]]);
    }));
    return function (_x28, _x29) {
      return _ref34.apply(this, arguments);
    };
  }()),
  createFamilies: (0, _underLoading.underLoadingFunction)(/*#__PURE__*/function () {
    var _ref36 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee15(_ref35, payload) {
      var commit, dispatch, response, successMessage, _t15;
      return _regenerator().w(function (_context15) {
        while (1) switch (_context15.p = _context15.n) {
          case 0:
            commit = _ref35.commit, dispatch = _ref35.dispatch;
            _context15.p = 1;
            _context15.n = 2;
            return _services.plotService.createFamilies(payload.idRow, payload.data);
          case 2:
            response = _context15.v;
            successMessage = _router.default.app.$t('success');
            _helpers.messageHelper.success(successMessage);
            return _context15.a(2, response);
          case 3:
            _context15.p = 3;
            _t15 = _context15.v;
            _helpers.errorResponseHelper.display(_t15);
            return _context15.a(2, false);
        }
      }, _callee15, null, [[1, 3]]);
    }));
    return function (_x30, _x31) {
      return _ref36.apply(this, arguments);
    };
  }()),
  updateFamilie: (0, _underLoading.underLoadingFunction)(/*#__PURE__*/function () {
    var _ref38 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee16(_ref37, payload) {
      var commit, dispatch, _yield$plotService$up2, data, successMessage, _t16;
      return _regenerator().w(function (_context16) {
        while (1) switch (_context16.p = _context16.n) {
          case 0:
            commit = _ref37.commit, dispatch = _ref37.dispatch;
            _context16.p = 1;
            _context16.n = 2;
            return _services.plotService.updateFamilie(payload.id, payload.data);
          case 2:
            _yield$plotService$up2 = _context16.v;
            data = _yield$plotService$up2.data;
            successMessage = _router.default.app.$t('success');
            _helpers.messageHelper.success(successMessage);
            return _context16.a(2, data);
          case 3:
            _context16.p = 3;
            _t16 = _context16.v;
            _helpers.errorResponseHelper.display(_t16);
            return _context16.a(2, false);
        }
      }, _callee16, null, [[1, 3]]);
    }));
    return function (_x32, _x33) {
      return _ref38.apply(this, arguments);
    };
  }()),
  deleteFamilies: (0, _underLoading.underLoadingFunction)(/*#__PURE__*/function () {
    var _ref40 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee17(_ref39, id) {
      var commit, rootState, response, successMessage, _t17;
      return _regenerator().w(function (_context17) {
        while (1) switch (_context17.p = _context17.n) {
          case 0:
            commit = _ref39.commit, rootState = _ref39.rootState;
            _context17.p = 1;
            _context17.n = 2;
            return _services.plotService.deleteFamilies(id);
          case 2:
            response = _context17.v;
            successMessage = _router.default.app.$t('pages.productive_areas.detail.alerts.delete_families_success');
            _helpers.messageHelper.success(successMessage);
            return _context17.a(2, response);
          case 3:
            _context17.p = 3;
            _t17 = _context17.v;
            _helpers.errorResponseHelper.display(_t17);
            return _context17.a(2, false);
        }
      }, _callee17, null, [[1, 3]]);
    }));
    return function (_x34, _x35) {
      return _ref40.apply(this, arguments);
    };
  }()),
  fetchBunches: (0, _underLoading.underLoadingFunction)(/*#__PURE__*/function () {
    var _ref42 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee18(_ref41, idFamilie) {
      var commit, dispatch, response, _t18;
      return _regenerator().w(function (_context18) {
        while (1) switch (_context18.p = _context18.n) {
          case 0:
            commit = _ref41.commit, dispatch = _ref41.dispatch;
            _context18.p = 1;
            _context18.n = 2;
            return _services.plotService.fetchBunches(idFamilie);
          case 2:
            response = _context18.v;
            return _context18.a(2, response.data);
          case 3:
            _context18.p = 3;
            _t18 = _context18.v;
            _helpers.errorResponseHelper.display(_t18);
            return _context18.a(2, false);
        }
      }, _callee18, null, [[1, 3]]);
    }));
    return function (_x36, _x37) {
      return _ref42.apply(this, arguments);
    };
  }()),
  createBunches: (0, _underLoading.underLoadingFunction)(/*#__PURE__*/function () {
    var _ref44 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee19(_ref43, payload) {
      var commit, dispatch, response, successMessage, _t19;
      return _regenerator().w(function (_context19) {
        while (1) switch (_context19.p = _context19.n) {
          case 0:
            commit = _ref43.commit, dispatch = _ref43.dispatch;
            _context19.p = 1;
            _context19.n = 2;
            return _services.plotService.createBunches(payload.idFamilie, payload.data);
          case 2:
            response = _context19.v;
            successMessage = _router.default.app.$t('success');
            _helpers.messageHelper.success(successMessage);
            return _context19.a(2, response);
          case 3:
            _context19.p = 3;
            _t19 = _context19.v;
            _helpers.errorResponseHelper.display(_t19);
            return _context19.a(2, false);
        }
      }, _callee19, null, [[1, 3]]);
    }));
    return function (_x38, _x39) {
      return _ref44.apply(this, arguments);
    };
  }()),
  updateBunches: (0, _underLoading.underLoadingFunction)(/*#__PURE__*/function () {
    var _ref46 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee20(_ref45, payload) {
      var commit, dispatch, _yield$plotService$up3, data, successMessage, _t20;
      return _regenerator().w(function (_context20) {
        while (1) switch (_context20.p = _context20.n) {
          case 0:
            commit = _ref45.commit, dispatch = _ref45.dispatch;
            _context20.p = 1;
            _context20.n = 2;
            return _services.plotService.updateBunches(payload.id, payload.data);
          case 2:
            _yield$plotService$up3 = _context20.v;
            data = _yield$plotService$up3.data;
            successMessage = _router.default.app.$t('success');
            _helpers.messageHelper.success(successMessage);
            return _context20.a(2, {
              data: data
            });
          case 3:
            _context20.p = 3;
            _t20 = _context20.v;
            _helpers.errorResponseHelper.display(_t20);
            return _context20.a(2, false);
        }
      }, _callee20, null, [[1, 3]]);
    }));
    return function (_x40, _x41) {
      return _ref46.apply(this, arguments);
    };
  }()),
  deleteBunches: (0, _underLoading.underLoadingFunction)(/*#__PURE__*/function () {
    var _ref48 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee21(_ref47, id) {
      var commit, rootState, response, successMessage, _t21;
      return _regenerator().w(function (_context21) {
        while (1) switch (_context21.p = _context21.n) {
          case 0:
            commit = _ref47.commit, rootState = _ref47.rootState;
            _context21.p = 1;
            _context21.n = 2;
            return _services.plotService.deleteBunches(id);
          case 2:
            response = _context21.v;
            successMessage = _router.default.app.$t('pages.productive_areas.detail.alerts.delete_bunch_success');
            _helpers.messageHelper.success(successMessage);
            return _context21.a(2, response);
          case 3:
            _context21.p = 3;
            _t21 = _context21.v;
            _helpers.errorResponseHelper.display(_t21);
            return _context21.a(2, false);
        }
      }, _callee21, null, [[1, 3]]);
    }));
    return function (_x42, _x43) {
      return _ref48.apply(this, arguments);
    };
  }()),
  getSubPlots: (0, _underLoading.underLoadingFunction)(/*#__PURE__*/function () {
    var _ref50 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee22(_ref49, payload) {
      var commit, dispatch, idPlot, _yield$plotService$fe, data, item, _t22;
      return _regenerator().w(function (_context22) {
        while (1) switch (_context22.p = _context22.n) {
          case 0:
            commit = _ref49.commit, dispatch = _ref49.dispatch;
            _context22.p = 1;
            idPlot = payload.plot ? payload.plot.id : payload.idPlot;
            _context22.n = 2;
            return _services.plotService.fetchSubPlot(idPlot);
          case 2:
            _yield$plotService$fe = _context22.v;
            data = _yield$plotService$fe.data;
            if (payload.plot) {
              if (!payload.plot.subplots || payload.plot.subplots && payload.plot.subplots.length <= 0) {
                item = {
                  payload: payload,
                  data: data
                };
                commit(MutationTypes.INSERT_SUBPLOTS_PLOTS, {
                  item: item
                });
              }
            }
            return _context22.a(2, data);
          case 3:
            _context22.p = 3;
            _t22 = _context22.v;
            _helpers.errorResponseHelper.display(_t22);
            return _context22.a(2, false);
        }
      }, _callee22, null, [[1, 3]]);
    }));
    return function (_x44, _x45) {
      return _ref50.apply(this, arguments);
    };
  }()),
  getFamilies: (0, _underLoading.underLoadingFunction)(/*#__PURE__*/function () {
    var _ref52 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee23(_ref51, payload) {
      var commit, dispatch, idRow, _yield$plotService$fe2, data, item, _t23;
      return _regenerator().w(function (_context23) {
        while (1) switch (_context23.p = _context23.n) {
          case 0:
            commit = _ref51.commit, dispatch = _ref51.dispatch;
            if (!(payload.item && payload.item.hasOwnProperty('families'))) {
              _context23.n = 1;
              break;
            }
            commit(MutationTypes.INSERT_FAMILIES_LINE, {
              item: {
                payload: payload
              }
            });
            return _context23.a(2, Promise.resolve());
          case 1:
            _context23.p = 1;
            idRow = payload.item ? payload.item.id : payload.row.id;
            _context23.n = 2;
            return _services.plotService.fetchFamilies(idRow);
          case 2:
            _yield$plotService$fe2 = _context23.v;
            data = _yield$plotService$fe2.data;
            if (payload.item && !payload.item.families && !payload.item.open) {
              item = {
                data: data.data,
                payload: payload
              };
              commit(MutationTypes.INSERT_FAMILIES_LINE, {
                item: item
              });
            }
            return _context23.a(2, Promise.resolve(data));
          case 3:
            _context23.p = 3;
            _t23 = _context23.v;
            return _context23.a(2, Promise.reject(_t23));
        }
      }, _callee23, null, [[1, 3]]);
    }));
    return function (_x46, _x47) {
      return _ref52.apply(this, arguments);
    };
  }()),
  getLines: (0, _underLoading.underLoadingFunction)(/*#__PURE__*/function () {
    var _ref54 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee24(_ref53, payload) {
      var commit, dispatch, _yield$plotService$fe3, data, item, _t24;
      return _regenerator().w(function (_context24) {
        while (1) switch (_context24.p = _context24.n) {
          case 0:
            commit = _ref53.commit, dispatch = _ref53.dispatch;
            if (!(payload.subPlot.hasOwnProperty('lines') && payload.subPlot.hasOwnProperty('open'))) {
              _context24.n = 1;
              break;
            }
            commit(MutationTypes.INSERT_LINES_SUBPLOTS, {
              item: {
                payload: payload
              }
            });
            return _context24.a(2, Promise.resolve());
          case 1:
            _context24.p = 1;
            _context24.n = 2;
            return _services.plotService.fetchLines(payload.subPlot.id);
          case 2:
            _yield$plotService$fe3 = _context24.v;
            data = _yield$plotService$fe3.data;
            if (!payload.subPlot.lines && !payload.subPlot.open) {
              item = {
                payload: payload,
                data: data.data
              };
              commit(MutationTypes.INSERT_LINES_SUBPLOTS, {
                item: item
              });
            }
            return _context24.a(2, Promise.resolve(data.data));
          case 3:
            _context24.p = 3;
            _t24 = _context24.v;
            return _context24.a(2, Promise.reject(_t24));
        }
      }, _callee24, null, [[1, 3]]);
    }));
    return function (_x48, _x49) {
      return _ref54.apply(this, arguments);
    };
  }()),
  getBunches: function () {
    var _getBunches = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee25(_ref55, payload) {
      var commit, dispatch, item, path, response, _item, _t25;
      return _regenerator().w(function (_context25) {
        while (1) switch (_context25.p = _context25.n) {
          case 0:
            commit = _ref55.commit, dispatch = _ref55.dispatch;
            if (payload.item && payload.item.hasOwnProperty('bunches')) {
              item = {
                payload: payload
              };
              commit(MutationTypes.INSERT_BUNCHES_FAMILIES, {
                item: item
              });
              Promise.resolve();
            }
            _context25.p = 1;
            path = "/families/".concat(payload.item.id, "/bunches");
            _context25.n = 2;
            return _http.default.get(path);
          case 2:
            response = _context25.v;
            if (payload.item && !payload.item.bunches && !payload.item.open) {
              _item = {
                payload: payload,
                data: response.data
              };
              commit(MutationTypes.INSERT_BUNCHES_FAMILIES, {
                item: _item
              });
            }
            return _context25.a(2, Promise.resolve(response.data));
          case 3:
            _context25.p = 3;
            _t25 = _context25.v;
            return _context25.a(2, Promise.reject(_t25));
        }
      }, _callee25, null, [[1, 3]]);
    }));
    function getBunches(_x50, _x51) {
      return _getBunches.apply(this, arguments);
    }
    return getBunches;
  }()
};
var _default = exports.default = {
  state: state,
  mutations: mutations,
  getters: getters,
  actions: actions
};